// extracted by mini-css-extract-plugin
export var createdDate = "_kw-1";
export var divider = "_kw-2";
export var headerDivider = "_kw-3";
export var messagesCard = "_kw-0";
export var messagesContainer = "_kw-6";
export var messagesContainerWrapper = "_kw-4";
export var showLeftPanelButton = "_kw-8";
export var topButtons = "_kw-7";
export var withPadding = "_kw-5";